import { render, staticRenderFns } from "./versionsManage.vue?vue&type=template&id=6d6835dc&"
import script from "./versionsManage.vue?vue&type=script&lang=js&"
export * from "./versionsManage.vue?vue&type=script&lang=js&"
import style0 from "./versionsManage.vue?vue&type=style&index=0&id=6d6835dc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports